import { PUBLIC_DO_ASSETS_URL } from '$env/static/public';

import { seoConfig } from '@shared/configs';

import { NewsApi } from '@entities/news';

import type { PageLoad } from './$types';

export const load: PageLoad = async ({ fetch, params }) => {
  const { slug } = params;
  const newsApi = new NewsApi(fetch);

  const newsArticle = await newsApi.readOne(slug);

  const defaultPreset = newsArticle.cover?.asset_transformations?.find(
    (preset) => preset.preset_key === 'default-1000w-webp' || preset.preset_key === 'default-500w-webp',
  );

  const breadcrumbs = [
    {
      name: 'Home',
      slug: '/',
      canonical: false,
    },
    {
      name: 'News',
      slug: '/news/',
      canonical: false,
    },
    {
      name: newsArticle.header,
      slug: `/article-${slug}/`,
      canonical: true,
    },
  ];

  const metaImage = newsArticle.cover
    ? {
        alt: newsArticle.header,
        caption: newsArticle.header,
        url: `${PUBLIC_DO_ASSETS_URL}/${defaultPreset?.transformation_name}`,
        width: newsArticle.cover?.width ?? 0,
        height: newsArticle.cover?.height ?? 0,
      }
    : undefined;

  const seo = seoConfig['news-article']({
    title: newsArticle.header,
    metaDescription: newsArticle.header,
    breadcrumbs,
    metaImage,
  });

  return { seo, article: newsArticle };
};
